export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      padding: '28px 28px 20px',
      borderBottom: '0.5px solid var(--color-border-light)',
      background: 'var(--color-bg-primary)',
    }}>
      <div>
        <div style={{ fontSize: 22, fontWeight: 400, color: 'var(--color-text-primary)' }}>{title}</div>
        {subtitle && <div style={{ fontSize: 13, color: 'var(--color-text-tertiary)', marginTop: 4 }}>{subtitle}</div>}
      </div>
      {actions && <div style={{ display: 'flex', gap: 8 }}>{actions}</div>}
    </div>
  );
}
